import { useContext } from "react";
import jobContext from "src/context/jobContext";

export default function Page({ children, className, pageNumber, isInnerPage = true }) {
    const { job } = useContext(jobContext)
    let baseInfo
    let jobTitle = job.title;
    if (localStorage.baseInfo) {
        baseInfo = JSON.parse(localStorage.baseInfo)
        jobTitle = baseInfo.jobTitle ?? job.title;
    }
    return (
        <div className="relative flex justify-center items-center p-10 w-[990px] max-w-[990px] max-h-[1404px] h-[1404px] border border-solid border-gray-300 shadow-sm rounded m-auto">
            {isInnerPage ?
                <div className="border-2 border-solid border-[#5b5cff] h-[1320px] w-full  overflow-hidden">
                    <div className="relative w-full h-6 bg-[#5b5cff] mt-6 px-12 text-white">
                        {pageNumber
                            ?
                            <div className="absolute flex justify-center items-center w-[40px] h-[40px] -top-2 left-20 bg-white shadow-lg rotate-[45deg] text-black border border-solid border-[#5b5cff] rounded-sm">
                                <div className="-rotate-[45deg]">{pageNumber}</div>
                            </div>
                            : null
                        }
                        {jobTitle}
                    </div>
                    <div className={`${className} flex flex-col gap-2 p-6`}>
                        {children}
                    </div>
                </div>
                :
                <div className="h-[1320px] w-full">
                    {children}
                </div>
            }
        </div>
    )
}